import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';
import { SalesOrderContractTask } from '@/hooks/api/models';

type Props = {
  children: ReactNode;
};

export type SalesOrderContractTaskContextType = {
  salesOrderContractTask?: SalesOrderContractTask;
  setSalesOrderContractTask: Dispatch<SetStateAction<SalesOrderContractTask | undefined>>;
}

const SalesOrderContractTaskContext = createContext<SalesOrderContractTaskContextType>({
  salesOrderContractTask: undefined,
  setSalesOrderContractTask: () => {
  }
});

export const SalesOrderContractTaskProvider = ({ children }: Props) => {
  const [salesOrderContractTask, setSalesOrderContractTask] = useState<SalesOrderContractTask>();

  return (
    <SalesOrderContractTaskContext.Provider value={{ salesOrderContractTask, setSalesOrderContractTask }}>
      {children}
    </SalesOrderContractTaskContext.Provider>
  );
};

export const useCurrentSalesOrderContractTask = () => {
  return useContext(SalesOrderContractTaskContext);
};